import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { ImagePickerComponent } from './image-picker.component';

@NgModule({
  declarations: [
    ImagePickerComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule
  ],
  exports: [
    ImagePickerComponent
  ]
})
export class ImagePickerModule { }
